import { Component, OnInit } from '@angular/core';
import { CommonService } from './../../services/common.service';


@Component({
  selector: 'app-is-alive',
  templateUrl: './is-alive.component.html'
})
export class IsAliveComponent implements OnInit {

  AliveResponse : any;
  constructor(private commonService: CommonService) { 

    this.commonService.isAlive().subscribe(response => {
      console.log(JSON.parse(JSON.stringify(response)));
      this.AliveResponse = JSON.stringify(response);
    }, error => {
        this.AliveResponse = JSON.stringify("Connection Not Successful");
    })
  }

  ngOnInit() {
  }

}
